export default "__VITE_ASSET__340d709b__"